import { useState } from "react";
export default function PricingFilter({
	openPopup,
	handleOpenPopup,
	filters,
	setFilters,
	setShowWarningModal,
}) {
	const [error, isError] = useState(null);
	const checkValidation = () => {
		if (!filters?.standingGuests && !filters?.sittingGuests) {
			isError("Select No. of Guests first");
			handleOpenPopup("guests");
			setShowWarningModal(true);
			return true;
		}
		isError(null);
		return false;
	};
	return (
		<>
			<div className="space-y-4 p-4 border rounded shadow-sm bg-white">
				{/* Budget Per Person */}
				<div className="flex items-center gap-3">
					<input
						type="radio"
						name="spendOption"
						className="form-radio h-4 w-4 text-blue-600"
						checked={filters.perPersonEnabled}
						onChange={(e) => {
							let isValidate = checkValidation();
							setFilters((prev) => ({
								...prev,
								perPersonEnabled: isValidate ? false : e.target.checked,
								venueRentalEnabled: false,
								minSpendEnabled: false,
								venueRental: { min: "", max: "" },
								minSpendPerEvent: { min: "", max: "" },
							}));
						}}
					/>
					<label className="w-full">Budget Per Person</label>
					<div className="flex flex-1 items-center justify-end gap-3">
						<input
							type="number"
							placeholder="Min"
							value={filters?.minSpendPerPerson?.min}
							onChange={(e) => {
								let isValidate = checkValidation();
								if (isValidate) return;
								setFilters((prev) => ({
									...prev,
									minSpendPerPerson: { min: e.target.value },
								}));
							}}
							disabled={!filters.perPersonEnabled}
							className="border p-1 rounded w-20"
						/>
						<input
							type="number"
							placeholder="Max"
							value={filters?.minSpendPerPerson?.max}
							onChange={(e) => {
								let isValidate = checkValidation();
								if (isValidate) return;
								setFilters((prev) => ({
									...prev,
									minSpendPerPerson: {
										min:
											prev?.minSpendPerPerson?.min &&
											prev?.minSpendPerPerson?.min !== ""
												? prev?.minSpendPerPerson?.min
												: 0,
										max: e.target.value,
									},
								}));
							}}
							disabled={!filters.perPersonEnabled}
							className="border p-1 rounded w-20"
						/>
					</div>
				</div>

				{/* Budget Per Event */}
				<div className="flex items-center gap-3">
					<input
						type="radio"
						name="venueRentalToggle"
						className="form-radio h-4 w-4 text-blue-600"
						checked={filters.venueRentalEnabled}
						onChange={(e) => {
							let isValidate = checkValidation();
							setFilters((prev) => ({
								...prev,
								venueRentalEnabled: isValidate ? false : e.target.checked,
								perPersonEnabled: false,
								minSpendEnabled: false,
								minSpendPerPerson: { min: "", max: "" },
								minSpendPerEvent: { min: "", max: "" },
							}));
						}}
					/>
					<label className="w-full">Budget Per Event</label>
					<div className="flex flex-1 items-center justify-end gap-3">
						<input
							type="number"
							placeholder="Min"
							value={filters?.venueRental?.min}
							onChange={(e) => {
								let isValidate = checkValidation();
								if (isValidate) return;
								setFilters((prev) => ({
									...prev,
									venueRental: { min: e.target.value },
								}));
							}}
							disabled={!filters.venueRentalEnabled}
							className="border p-1 rounded w-20"
						/>
						<input
							type="number"
							placeholder="Max"
							value={filters?.venueRental?.max}
							onChange={(e) => {
								let isValidate = checkValidation();
								if (isValidate) return;
								setFilters((prev) => ({
									...prev,
									venueRental: {
										min:
											prev?.venueRental?.min && prev?.venueRental?.min !== ""
												? prev?.venueRental?.min
												: 0,
										max: e.target.value,
									},
								}));
							}}
							disabled={!filters.venueRentalEnabled}
							className="border p-1 rounded w-20"
						/>
					</div>
				</div>
			</div>
		</>
	);
}
